module.exports = __webpack_public_path__ + "media/images/illustrations/coins-falling-coin-crossed-722f9fc5b4be52c02c4dddefe8b382e1.svg";